export const irctcSavedIds = {
    NOT_SHOWN: 0, 
    SHOWN: 1,
};

// Value for showNewTrainSchedule() used for new variant of train schedule
export const trainScheduleV2 = {
    NOT_SHOWN: 0, 
    SHOWN: 1,
}

// Value for railsConfirmOptionsV2() used for new variant of confirm options
export const ConfirmOptionsV2 = {
    NOT_SHOWN: 0,
    SHOWN: 1,
  UX_V2: 2,
}

// Value for hideAvailabilityMarkers() used for hiding of availability markers
export const AvailabilityMarkers = {
    SHOWN: false,
    HIDDEN: true,
}

// Value for getMealsNewFlow() used for new variant of meals
export const MealsNewFlow = {
  NOT_SHOWN: false,
  SHOWN: true,
}

// Value for getMealsDirectWebviewEntry() used for direct webview entry point
export const MealsDirectWebviewEntry = {
  NOT_SHOWN: false,
  SHOWN: true,
}

// Value for Availability changed from AVL to WL
export const AvailabilityAvlToWl = {
  SHOWN: 1,
  NOT_SHOWN: 0,
};

// Value to select the NEW -> 'mmt_rails_b2c_pdt_client_logging_v2' or OLD -> 'mmt_rails_b2c_pdt_client_logging'
export const PDTclientSchemaV2new = {
    V2_PDT_CLIENT_SCHEMA_SELECTED: true,
    OLD_PDT_SCHEMA_SELECTED: false,
}

// Value for showAddMoreTravellerFlow() used for new variant of add more traveller flow
export const AddMoreTravellerFlow = {
  NOT_SHOWN: 0,
  SHOWN: 1,
};

// value to show connected travel variants
export const connectedTravelVariants = {
  NOT_SHOWN: 0,
  SHOWN_EXPANDED_CARD: 1,
  INTRODUCING_CONNECTED_TRAVEL: 2,
  MOVED_DIRECT_LISTING: 3,
};

// Value for show Trust Markers on landing page
export const rtbLanding = {
  NOT_SHOWN: 0,
  SHOWN: 1,
};

// Value for show Trust Markers on listing page
export const rtbListing = {
  NOT_SHOWN: 0,
  SHOWN: 1,
};

//Value to Show Previously Booked
export const PreviouslyBooked = {
  NOT_SHOWN: 0,
  SHOWN: 1,
};

//Value to Show Previously Searched
export const PreviouslySearched = {
  NOT_SHOWN: 0,
  SHOWN: 1,
};

// Value for show new SEM landing page
export const SEM_LANDING_PAGE = {
  NOT_SHOWN: 0,
  SHOWN: 1,
};

// Value for showing Traveller Urgency BottomSheet
export const TRAVELLER_URGENCY_BS = {
  NOT_SHOWN: false,
  SHOWN: true,
};

// Value for showing Review Error Alerts Timer
export const RAILS_ARP_HANLDING_BS = {
  NOT_SHOWN: 0,
  SHOWN: 1,
};

//Value for Default Date
export const LANDING_DEFAULT_DATE = {
  TODAY: 0,
  TOMORROW: 1,
};

// Value for showing Aadhar Linking Banner on Listing Page
export const LISTING_EDUCATION_CARD = {
  SHOW_LINK_AADHAR: 'TA',
  SHOW_TICKETS_RUNNING_OUT: 'RE',
};

//Value for Showing avl toast for confirmed options trains
export const TRAVELLER_AVL_TOAST = {
  NOT_SHOWN: 0,
  SHOWN: 1,
};

//Value for Showing Listing Sold out Banner
export const LISTING_TRAINS_SOLD_OUT_BANNER = {
  NOT_SHOWN: 0,
  SHOWN: 1,
};

//Fallback for Sorting Logic is 1
export const LISTING_SORTING_LOGIC = {
  DEFAULT_LOGIC: 1,
};

// Value for WL Urgency Persuasion feature
export const WlUrgencyPersuasion = {
  NOT_SHOWN: 0,
  SHOWN: 1,
};

// Pokus for showing Aadhar Linking Banner on Listing Page
export const LISTING_EDUCATION_CARD_Pokus = {
  SHOW: 1,
  DONOT_SHOW: 0,
};

// value to show TG+WL Cards in route extension
export const WlTgCardsRouteExtension = {
  NOT_SHOWN: 0,
  SHOWN: 1,
};
